import {gtmEvent, loggedOutSegment} from './helpers'

export const ctaClick = (location) => loggedOutSegment('Black Desk CTA Clicked', {location})

export const blackDeskHeroCtaClicked = () => ctaClick('hero')
export const blackDeskFooterCtaClicked = () => ctaClick('footer')

export const blackDeskVendorSignup = (email) => {
  gtmEvent('blackDeskVendorSignup')
  loggedOutSegment('Black Desk Vendor Signup', {email})
}

/* eslint-disable camelcase */
export const blackDeskSubmitAddress = ({city, state, zip_code}) =>
  loggedOutSegment('Black Desk Address Submit', {city, state, zip: zip_code})
/* eslint-enable camelcase */
